module.exports = __webpack_public_path__ + "img/sohba-2.8e57a34.webp";